export default 
{
	"progressbar-page-title": "页",
	"name-suffix": "后缀",
	"fileupload-desc-progress-message": "上传 {progress}",
	"required-if-greater-than-or-equal": "{compareSource} 是大于或等于 {compareValue}，{property} 时所需。",
	"powered-by-cognito": "由 Cognito Forms 提供动力。",
	"form-name-default": "无题",
	"field-choice-defaults": "第一选择|第二选择|第三种选择",
	"additional-fee-default-label": "额外费用",
	"authenticated-save-and-resume-email-dialog": "透過電子郵件傳送連結，並返回您的表格以完成提交。",
	"string-length-between": "{property} 必须介于 {min} 和 {max} 字符。",
	"update-button-text": "执行更新",
	"address-zip-code-invalid": "Zip 代码必须格式化为 #####-####。",
	"required-if-greater-than": "当 {compareSource} {compareValue} 大于时，{property} 是必需的。",
	"compare-before": "{property} {compareSource} 之前必须。",
	"compare-after": "{property} 必须后 {compareSource}。",
	"unsupported-browser-message": "哦上 ！您正在使用上受支持的浏览器。{} $a在这里单击 {/a} 以升级。",
	"shared-entry-email-subject": "共享链接",
	"send-button-text": "发送",
	"venmo-help-text": "连接到 Venmo 以继续付款。",
	"field-repeatingsection-item-label": "项目",
	"save-and-resume-email-not-sent-message": "出現問題了。",
	"credit-card-cvv": "信用卡安全码",
	"range-at-least": "至少必须为 {property} {min}。",
	"entry-notification-full-entry-detail-link": "在 cognitoforms.com 查看完整的条目详细信息。",
	"element-label-website": "网站",
	"element-label-signature": "签名",
	"paypal-help-text": "连接到 PayPal 以继续付款。",
	"card-on-file-agreement-validation": "您必须同意保存您的卡以用于将来的交易。",
	"marketing-button-4": "Build Your Own for Free",
	"field-datepicker-now": "此刻",
	"save-and-resume-email-resume-button": "现在简历",
	"field-datepicker-next-month": "下个月",
	"quantity-remaining-text": "其余",
	"payment-declined": "拒绝付款",
	"required-if-before": "当 {compareSource} {compareValue} 之前时，{property} 是必需的。",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} 必须小于 {compareSource}。",
	"entry-admin-link": "",
	"required-many": "{0} 必填项。",
	"save-and-resume-multiple-days-expiration-email-message": "复制或电子邮件下面的链接，并在未来返回到您的形式{days}天完成提交。",
	"string-length-at-least": "至少必须为 {property} {min} 字符。",
	"credit-card-number": "信用卡的卡号",
	"range-on-or-before": "{property} 必须或以前 {max}。",
	"required-one": "{0} 是必需的。",
	"fileupload-max-file-count-exceeded-message": "只有 {maxFileCount} 文件可能会上载。",
	"order-transaction-details-header": "交易记录详细信息",
	"field-spinner-increase": "增加",
	"payment-processing-fees": "加工费",
	"payment": "付款",
	"field-choice-other-fill-in": "其他",
	"shared-entry-email-message": "一个条目已与您共享。",
	"shared-entry-workflow-link": "查看表格。",
	"required-if-exists": "如果指定了 {compareSource}，{property} 是必需的。",
	"concurrent-conflict-toast-message": "提交失敗，因為表單數據已更改。請檢查並重試。",
	"secured-by-paypal": "受保护",
	"range-on-or-after": "{property} 必须当日或之后 {min}。",
	"payment-amount-due": "到期金额",
	"required-name-first-and-last": "第一次和最后的要求。",
	"required": "{property} 是必需的。",
	"string-format-alphabetic": "{property} 必须只包含字母。",
	"quantity-limit": "{property} 数量超标。",
	"field-spinner-decrease": "减少",
	"field-repeatingsection-add-link-text": "添加",
	"fileupload-max-size-exceeded-message": "可以上载仅小于 {maxSize} MB 的文件。",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "未被捕获",
	"field-ratingscale-satisfied-unsatisfied-label": "满意不满意",
	"range-between": "{property} 必须介于 {min} 和 {max}。",
	"field-ratingscale-agree-disagree-label": "同意不同意",
	"back-button-text": "返回",
	"address-country": "国家",
	"order-not-found": "没有找到的订单信息。",
	"field-ratingscale-satisfied-unsatisfied-options": "很不满意|不满意|中立|满足|非常满意",
	"entry-notification-entry-details-header": "条目详细信息",
	"FALSE": "假",
	"compare-greater-than-or-equal": "{property} 必须大于或等于 {compareSource}。",
	"receipt-notification-order-details-desc-header": "描述",
	"order-method-label": "方法",
	"order-total-label": "订单合计",
	"invalid-shared-link": "无效的共享链接",
	"fileupload-zero-byte-file-message": "可以上载零字节文件。",
	"range-at-most": "{property} 必须在大多数 {max}。",
	"format-integer": "####",
	"order-date-label": "日期",
	"fileupload-dropzone-message": "或将文件拖到此处。",
	"shared-entry-view-link": "查看共享条目。",
	"format-currency": "¥#,###.##",
	"string-length-at-most": "{property} 必须顶多是 {max} 字符。",
	"entry-confirmation-footer-tagline": "创建您自己的功能强大的支付形式与",
	"submit-button-text": "提交",
	"marketing-msg": "Easily create powerful forms.",
	"required-if-on-or-after": "{compareSource} 是当日或之后 {compareValue}，{property} 时所需。",
	"card-on-file-agreement": "我同意保存我的卡以备将来交易。",
	"signature-draw": "绘图",
	"address-zip-code": "邮政编码",
	"compare-on-or-after": "{property} 必须当日或之后 {compareSource}。",
	"required-if-less-than-or-equal": "当 {compareSource} 时小于或等于 {compareValue}，{property} 是必需的。",
	"field-datepicker-next-year": "后一年",
	"change-button": "改变",
	"fileupload-desc-size-in-bytes-message": "{size} 字节为单位）",
	"card-tab": "卡片",
	"order-billing-info-header": "付费信息",
	"entry-email-view-details-text": "在 CognitoForms.com 查看完整的条目。",
	"save-and-resume-one-day-expiration-email-message": "复制或电子邮件下面的链接，并返回到您的窗体在第二天完成提交。",
	"credit-card-authentication-failed": "卡验证失败。",
	"compare-less-than-or-equal": "{property} 必须小于或等于 {compareSource}。",
	"receipt-notification-order-details-balance-due": "未付差额",
	"save-and-resume-multiple-days-expiration-message": "复制或电子邮件下面的链接，并在未来返回到您的形式{days}天完成提交。",
	"processing-fee-calculating-message": "计算",
	"receipt-notification-trx-details-method": "方法",
	"field-choice-no-match": "无匹配数据",
	"fileupload-invalid-file-type-message": "只有 {allowedTypes} 文件可能会上载。",
	"receipt-notification-trx-details-date": "日期",
	"credit-card-authorization": "卡授权",
	"address-line1": "地址行 1",
	"required-if-not-exists": "{property} {compareSource} 未指定时是必需的。",
	"required-if-not-equal": "{property} {compareSource} 上是时需要 {compareValue}。",
	"marketing-button-2": "Build Your Own for Free",
	"receipt-notification-billing-info-header": "付费信息",
	"required-if-after": "当 {compareSource} {compareValue} 后时，{property} 是必需的。",
	"element-label-name": "名称",
	"required-if-equal": "当 {compareSource} {compareValue} 时，{property} 是必需的。",
	"connected-to-paypal": "已连接至 PayPal。",
	"people-form-email-quantity-exceeded-message": "电子邮件地址必须是唯一的。",
	"receipt-notification-order-details-subtotal": "小计",
	"shared-entry-edit-link": "编辑共享条目。",
	"receipt-notification-trx-details-header": "交易记录详细信息",
	"address-city": "城市",
	"receipt-notification-order-details-amount-paid": "支付金额",
	"credit-card-invalid": "卡无效",
	"format-decimal": "####.##",
	"entry-notification-new-submission-text": "你有新的表单提交。",
	"this-and-that": "{0} 和 {1}",
	"field-ratingscale-good-poor-label": "好/不好",
	"network-unavailable-message": "网络不可用，请稍后再试。",
	"dialog-close": "关",
	"string-format-alphanumeric": "{property} 必须只包含字母和数字。",
	"credit-card": "信用卡",
	"remove-item": "去掉 {item}",
	"receipt-notification-order-details-price-header": "价格",
	"fileupload-upload-inprogress-message": "进步的文件上传。",
	"public-terms-of-service-link-text": "服务条款",
	"save-and-resume-email-subject": "保存并恢复链接",
	"field-repeatingsection-remove-link-text": "去掉",
	"field-ratingscale-na-label": "N/A",
	"add-item": "添加",
	"field-toggle-options": "是/否|真/假|打开/关闭|激活/禁用|读/未读",
	"order-submit-timeout": "订单处理时间太长。请稊后尝试您的订单。",
	"listlength-at-most": "请指定上超过{max} {property}多。",
	"shared-entry-email-view-message": "使用下面的链接查看共享条目。",
	"order-number-label": "编号",
	"card-declined": "卡被拒绝",
	"fileupload-default-upload-button-text": "上传",
	"name-prefix": "标题",
	"address-line2": "地址行 2",
	"element-label-email": "电子邮件",
	"field-ratingscale-good-poor-options": "很差|穷人|平均|好|非常好",
	"next-button-text": "下一个",
	"question": "问题",
	"address-postalcode": "邮政邮编",
	"format-with-description": "{property} 必须格式化为 {description}。",
	"field-datepicker-prev-month": "上个月",
	"name": "吊称",
	"receipt-notification-order-details-total-footer": "总计",
	"confirmation-message": "感谢您填写表单。已记录你的反应。",
	"shared-entry-email-edit-message": "使用下面的链接编辑共享条目。",
	"field-default-label": "无题",
	"required-value": "{property} 必须为 {value}。",
	"name-middle": "中东",
	"fileupload-failed-upload-message": "{fileName} 未能上传。",
	"shared-entry-email-button-label": "查看该条目",
	"field-datepicker-year": "年",
	"element-label-phone": "电话",
	"TRUE": "真实",
	"listlength-between": "请{min}和{max} {property}之间的指定。",
	"marketing-button-1": "Try It Now",
	"entry-submission-error-heading": "错误处理条目",
	"order-not-found-message": "没有找到的订单信息。",
	"format-without-description": "{property} 的格式上正确。",
	"name-last": "最后",
	"field-ratingscale-one-five-label": "1 到 5 级",
	"listlength-at-least": "请指定至少 {min} {property}。",
	"united-states": "美国",
	"field-signature-captured": "抓获",
	"compare-on-or-before": "{property} 必须或以前 {compareSource}。",
	"order-balance-due-label": "未付差额",
	"required-if-less-than": "当 {compareSource} {compareValue} 小于时，{property} 是必需的。",
	"credit-card-postalcode": "邮政邮编",
	"form-not-available-message": "此窗体当前不可用。",
	"element-label-address": "地址",
	"receipt-notification-trx-details-number": "数量",
	"public-submission-warning": "请不要提交密码通过 Cognito Forms。",
	"save-and-resume-no-expiration-email-message": "复制或电子邮件下面的链接，并返回到您的形式完成提交。",
	"fileupload-excluded-file-type-message": "此类型的文件可能无法上载。",
	"payment-subtotal": "小计",
	"collapse": "折叠",
	"save-button-text": "保存",
	"field-datepicker-prev-year": "前一年",
	"signature-type": "键入",
	"order-amount-minimum": "应付金额必须至少 ¥1.00 美元。",
	"string-format-numeric": "{property} 必须只包含数字。",
	"entry-confirmation-entry-details-header": "条目详细信息",
	"connected-to-venmo": "已连接至 Venmo。",
	"format-percentage": "#.##%",
	"receipt-notification-header": "收据",
	"clear": "明确",
	"today": "今天",
	"required-name-last": "最后是必需的。",
	"marketing-button-3": "Try It Now",
	"expand": "展开",
	"compare-greater-than": "{property} 必须大于 {compareSource}。",
	"field-ratingscale-will-wont-label": "会 / 不会",
	"required-name-first": "首先是必需的。",
	"save-and-resume-one-day-expiration-message": "复制或电子邮件下面的链接，并返回到您的窗体在第二天完成提交。",
	"required-asterisk": "是必需的",
	"credit-card-required": "信用卡是必需的。",
	"address-state-province-region": "州 / 省 / 地区",
	"save-and-resume-email-sent-message": "电子邮件已发送。",
	"workflow-action": "行动",
	"field-ratingscale-will-wont-options": "绝对不会|可能不会|不能确定|可能会| 肯定会",
	"save-and-resume-email-label": "发邮件给我我的链接：",
	"field-ratingscale-agree-disagree-options": "强烈不同意|不同意|中立|同意|非常同意",
	"order-exception-order-already-paid": "此订单已经支付。",
	"fileupload-download-text": "下载",
	"address-state": "状态",
	"allowed-values": "{property} 上是允许值的列表。",
	"shared-entry-workflow-email-button-label": "打开表格",
	"compare-equal": "{property} 必须 {compareSource} 相同。",
	"field-datepicker-clear": "清空",
	"name-first": "第一次",
	"save-and-resume-message": "你的进步已保存。",
	"save-and-resume-no-expiration-message": "复制或电子邮件下面的链接，并返回到您的形式完成提交。",
	"entry-notification-view-details-text": "查看详细信息",
	"order-exception-default-message": "无法处理的交易记录。",
	"public-report-abuse-link-text": "报告滥用行为",
	"order-amount-paid": "支付金额",
	"element-label-default": "无题",
	"countries": "Hong 港|Vincent 和格林纳丁斯|阿尔巴尼亚|阿尔及利亚|阿富汗|阿根廷|阿拉伯联合酋长国|阿鲁巴|阿曼|阿塞拜疆|埃及|埃塞俄比亚|爱尔兰|爱沙尼亚|安道尔|安哥拉|安圭拉|安提瓜和巴布达|奥地利|澳大利亚|澳门|巴巴多斯|巴布亚新几内亚|巴哈马|巴基斯坦|巴拉圭|巴勒斯坦领土|巴林|巴拿马|巴西|白俄罗斯|百慕大|保加利亚|北马里亚纳群岛|贝宁|比利时|冰岛|波多黎各|波兰|波斯尼亚和黑塞哥维那|玻利维亚|伯利兹|博茨瓦纳|上丹|布吉纳法索|布隆迪|赤道几内亚|大上列颠|大韩民国 (南韩)|丹麦|德国|东帝汶 （东帝汶）|多哥|多米尼加共和国|多米尼克|俄罗斯联邦|厄瓜多尔|厄立特里亚|法国|法国南部领地|法罗群岛|法属波利尼西亚|法属圭亚那|梵蒂冈城国 （罗马教廷）|菲律宾|斐济|芬兰|佛得角|福克兰群岛|冈比亚|刚果 (金) 民主共和国|刚果共和国 of(Brazzaville)|哥伦比亚|哥斯达黎加|格林纳达|格陵兰岛|格鲁吉亚|古巴|瓜德罗普岛|关岛|圭亚那|哈萨克斯坦|海地|韩国，民主党人 \u0027 s 众议员 (朝鲜)|荷兰|荷属安地列斯群岛|黑山|洪都拉斯|基里巴斯|吉布提|吉尔吉斯斯坦|几内亚|几内亚比绍|加拿大|加纳|加蓬|柬埔寨|捷克共和国|津巴布韦|喀麦隆|卡塔尔|开曼群岛|科科斯 (基林) 群岛|科摩罗|科索沃|科威特|克罗地亚|肯尼亚|库克群岛|拉托维亚|莱索托|老挝、 人 \u0027 s 民主共和国|黎巴嫩|立陶宛|利比里亚|利比亚|列支敦士登|留尼汪岛|卢森堡|卢旺达|罗马教廷|罗马尼亚|马恩岛|马达加斯加|马尔代夫|马耳他|马拉维|马来西亚|马里|马其顿的众议员|马绍尔群岛|马提尼克岛|马约特岛|毛里求斯|毛里塔尼亚|美国|美属萨摩亚|蒙古|蒙特塞拉特岛|孟加拉国|秘鲁|密克罗尼西亚联邦国|缅甸缅甸|摩尔多瓦共和国|摩洛哥|摩纳哥|莫桑比克|墨西哥|纳米比亚|南非|南极洲|南苏丹|瑙鲁|尼泊尔|尼加拉瓜|尼日尔|尼日利亚|纽埃|挪威|帕劳|皮特凯恩岛|葡萄牙|日本|瑞典|瑞士|萨尔瓦多|萨摩亚|塞尔维亚|塞拉利昂|塞内加尔|塞浦路斯|塞舌尔|沙特阿拉伯|圣诞岛|圣多美和普林西比|圣基茨和尼维斯|圣卢西亚|圣马利诺|斯里兰卡|斯洛伐克 (斯洛伐克共和国)|斯洛文尼亚|斯威士兰|苏丹|苏里南|索罗门群岛|索马里|塔吉克斯坦|台湾 （中华民国）|泰国|坦桑尼亚 ；正式的坦桑尼亚联合共和国|汤加|特克斯和凯科斯群岛|特立尼达和多巴哥|突尼斯|图瓦卢|土耳其|土库曼斯坦|托克劳|瓦利斯群岛和富图纳群岛|瓦努阿图|危地马拉|维尔京群岛 （美国）|维尔京群岛 (英属)|委内瑞拉|文莱达鲁萨兰国|乌干达|乌克兰|乌拉圭|乌兹别克斯坦|西班牙|西藏|西撒哈拉|希腊|象牙海岸|新加坡|新喀里多尼亚|新西兰|匈牙利|叙利亚、 阿拉伯叙利亚共和国|牙买加|亚美尼亚|也门|伊拉克|伊朗 (伊斯兰共和国)|以色列|意大利|印度|印度尼西亚|英国|约旦|越南|赞比亚|乍得|直布罗陀|智利|中非共和国|中国",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "订单必须包含至少 1 行项。",
	"compare-not-equal": "{property} 必须上同于 {compareSource}。",
	"entry-notification-footer": "您会收到这封电子邮件，因为您选择接收电子邮件通知选项 Cognito Forms 在窗体上。",
	"save-and-resume-copy-link-label": "您复制链接表：",
	"entry-confirmation-footer": "您会收到这封电子邮件，因为您完成交易 [Name].",
	"required-if-on-or-before": "当 {compareSource} 时或之前 {compareValue}，{property} 是必需的。",
	"string-format": "{property} 必须格式化为 {formatDescription}。"
};
